import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "cookies"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Politique de cookies ")
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Nous utilisons des cookies pour mesurer notre audience, améliorer notre site et vous proposer des offres personnalisées, conformément aux dispositions de "),
  /*#__PURE__*/_createElementVNode("a", { href: "/conditions-generales" }, "notre politique de confidentialité"),
  /*#__PURE__*/_createTextVNode(". "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Vous pouvez accepter ou refuser ces traitements en cliquant sur les boutons ci-dessous. ")
], -1)
const _hoisted_4 = { class: "buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (this.show)
    ? (_openBlock(), _createElementBlock("aside", _hoisted_1, [
        _createElementVNode("div", null, [
          _createElementVNode("h5", null, [
            _hoisted_2,
            _createVNode(_component_font_awesome_icon, { icon: "cookie-bite" })
          ]),
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (this.accept('no')))
            }, " Continuer sans accepter "),
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (this.accept('yes')))
            }, " Accepter tout ")
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}